import { Table } from "antd";

const Table4 = () => {
    const dataSource = [
        {
            key: 1,
            group: 'Nhóm 1',
            industry: 'Bệnh viện (Tham gia chương trình Bệnh viện Công của Visa)',
            domesticBidv: '0.65%',
            domesticOther: '0.78%',
            visaBidv: '0.92%',
            visaOther: '1.05%',
            visaForeign: '3.53%',
            masterBidv: '0.92%',
            masterOther: '2.75%',
            masterForeign: '3.38%',
            cup: '2.5%',
            jcb: '2.5%',
        },
        {
            key: 2,
            group: 'Nhóm 2',
            industry: 'Bệnh viện (Không tham gia Chương trình BV công)',
            domesticBidv: '0.65%',
            domesticOther: '0.78%',
            visaBidv: '0.92%',
            visaOther: '2.41%',
            visaForeign: '3.46%',
            masterBidv: '0.92%',
            masterOther: '2.81%',
            masterForeign: '3.45%',
            cup: '2.5%',
            jcb: '2.5%',
        },
        {
            key: 3,
            group: 'Nhóm 3',
            industry: 'Siêu thị',
            domesticBidv: '0.65%',
            domesticOther: '0.78%',
            visaBidv: '1.30%',
            visaOther: '1.32%',
            visaForeign: '3.88%',
            masterBidv: '1.24%',
            masterOther: '1.73%',
            masterForeign: '3.88%',
            cup: '2.5%',
            jcb: '2.5%',
        },
        {
            key: 4,
            group: 'Nhóm 4',
            industry: 'Nhà hàng Đồ ăn Nhanh',
            domesticBidv: '0.65%',
            domesticOther: '0.78%',
            visaBidv: '1.24%',
            visaOther: '1.30%',
            visaForeign: '3.74%',
            masterBidv: '1.24%',
            masterOther: '1.44%',
            masterForeign: '3.73%',
            cup: '2.5%',
            jcb: '2.5%',
        },
        {
            key: 5,
            group: 'Nhóm 5',
            industry: 'Cửa hàng Điện tử',
            domesticBidv: '0.65%',
            domesticOther: '0.78%',
            visaBidv: '1.24%',
            visaOther: '1.70%',
            visaForeign: '3.47%',
            masterBidv: '1.24%',
            masterOther: '2.71%',
            masterForeign: '3.41%',
            cup: '2.5%',
            jcb: '2.5%',
        },
        {
            key: 6,
            group: 'Nhóm 6',
            industry: 'Dịch vụ Bảo hiểm',
            domesticBidv: '0.65%',
            domesticOther: '0.78%',
            visaBidv: '1.24%',
            visaOther: '1.25%',
            visaForeign: '3.18%',
            masterBidv: '1.24%',
            masterOther: '2.88%',
            masterForeign: '3.53%',
            cup: '2.5%',
            jcb: '2.5%',
        },
        {
            key: 7,
            group: 'Nhóm 7',
            industry: 'Quản lý và Đại lý Cho thuê Bất động sản',
            domesticBidv: '0.65%',
            domesticOther: '0.78%',
            visaBidv: '1.24%',
            visaOther: '1.20%',
            visaForeign: '3.71%',
            masterBidv: '1.24%',
            masterOther: '2.88%',
            masterForeign: '3.21%',
            cup: '2.5%',
            jcb: '2.5%',
        },
        {
            key: 8,
            group: 'Nhóm 8',
            industry: 'Taxi & Limousine',
            domesticBidv: '0.65%',
            domesticOther: '0.78%',
            visaBidv: '1.35%',
            visaOther: '1.35%',
            visaForeign: '4.66%',
            masterBidv: '1.35%',
            masterOther: '1.35%',
            masterForeign: '4.66%',
            cup: '2.5%',
            jcb: '2.5%',
        },
        {
            key: 9,
            group: 'Nhóm 9',
            industry: 'Cây xăng',
            domesticBidv: '0.65%',
            domesticOther: '0.78%',
            visaBidv: '1.24%',
            visaOther: '1.24%',
            visaForeign: '3.64%',
            masterBidv: '1.24%',
            masterOther: '1.24%',
            masterForeign: '3.61%',
            cup: '2.5%',
            jcb: '2.5%',
        },
    ];

    const columns = [
        {
            title: 'STT',
            dataIndex: 'group',
            key: 'group',
            width: 60,
            align: 'center',
        },
        {
            title: 'Các ngành nghề',
            dataIndex: 'industry',
            key: 'industry',
            width: 220,
        },

        // ==================== THẺ NỘI ĐỊA ====================
        {
            title: 'Thẻ nội địa',
            children: [
                {
                    title: (
                        <>
                            Thẻ
                            <br />
                            BIDV
                        </>
                    ),
                    dataIndex: 'domesticBidv',
                    key: 'domesticBidv',
                    width: 60,
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Thẻ
                            <br />
                            NH khác
                        </>
                    ),
                    dataIndex: 'domesticOther',
                    key: 'domesticOther',
                    width: 60,
                    align: 'center',
                },
            ],
        },

        // ==================== THẺ VISA ====================
        {
            title: 'Thẻ Visa',
            children: [
                {
                    title: (
                        <>
                            Thẻ
                            <br />
                            BIDV
                        </>
                    ),
                    dataIndex: 'visaBidv',
                    key: 'visaBidv',
                    width: 60,
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Thẻ
                            <br />
                            NH khác
                        </>
                    ),
                    dataIndex: 'visaOther',
                    key: 'visaOther',
                    width: 60,
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Thẻ
                            <br />
                            Nước ngoài
                        </>
                    ),
                    dataIndex: 'visaForeign',
                    key: 'visaForeign',
                    width: 65,
                    align: 'center',
                    className: 'fee-red',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                },
            ],
        },

        // ==================== THẺ MASTER ====================
        {
            title: 'Thẻ Master',
            children: [
                {
                    title: (
                        <>
                            Thẻ
                            <br />
                            BIDV
                        </>
                    ),
                    dataIndex: 'masterBidv',
                    key: 'masterBidv',
                    width: 60,
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Thẻ
                            <br />
                            NH khác
                        </>
                    ),
                    dataIndex: 'masterOther',
                    key: 'masterOther',
                    width: 60,
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Thẻ
                            <br />
                            Nước ngoài
                        </>
                    ),
                    dataIndex: 'masterForeign',
                    key: 'masterForeign',
                    width: 65,
                    align: 'center',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                },
            ],
        },

        // ==================== CUP ====================
        {
            title: (
                <>
                    Thẻ
                    <br />
                    CUP
                </>
            ),
            dataIndex: 'cup',
            key: 'cup',
            width: 60,
            align: 'center',
            render: (value) => (
                <span className="text-danger">{value}</span>
            ),
        },

        // ==================== JCB ====================
        {
            title: (
                <>
                    Thẻ
                    <br />
                    JCB
                </>
            ),
            dataIndex: 'jcb',
            key: 'jcb',
            width: 60,
            align: 'center',
            render: (value) => (
                <span className="text-danger">{value}</span>
            ),
        },
    ];
    return (
        <div className="mt-5">
            <h2 className="fw-bold fs-4 mb-3 text-center">BẢNG 4: BIỂU PHÍ POS – áp dụng với khách hàng sử dụng dịch vụ từ ngân hàng BIDV </h2>
            <div>
                <Table
                    bordered
                    pagination={false}
                    dataSource={dataSource}
                    columns={columns}
                    rowKey="key"
                />
            </div>
        </div>

    );
};
export default Table4;